export default [{
    dictKey: '',
    dictValue: '全部'
}, {
    dictKey: '0',
    dictValue: '未知交易'
}, {
    dictKey: '1',
    dictValue: '认证',
}, {
    dictKey: '2',
    dictValue: '购买等级（缴费升级）',
}, {
    dictKey: '3',
    dictValue: '购买身份（买K5或者6990等）',
}, {
    dictKey: '4',
    dictValue: '办信用卡',
}, {
    dictKey: '5',
    dictValue: '卡测评',
}, {
    dictKey: '6',
    dictValue: '优惠券',
}];




// WEBPACK FOOTER //
// ./src/service/constant/ValueAddedType.js